<div class="page-content" *ngIf="rfxMetaData$ | async as rfxMetaData">
  <div class="page-title-row">
    <h3 class="page-title">Crosses from {{ rfxMetaData.incumbentSecondaryDisplayValue }}</h3>
    <button mat-button (click)="navigateToMyRequests()" id="myRequestsButton" color="primary">
      <mat-icon>chevron_left</mat-icon>
      My Requests
    </button>
  </div>

  <ng-container *ngIf="(vm$ | async) as vm; else loadingTemplate">
    <div class="button-container">
      <div class="start-btn-group">
        <div class="conversion-btn" >
          <button mat-raised-button
                  id="selectConversionButton"
                  color="primary"
                  (click)="openSelectConversionDialog()"
                  [disabled]="vm.incumbentProducts.length === 0">
            Select Conversion
          </button>
        </div>
        <div class="rfx-month-filter" *ngIf="vm.selectedConversionTarget || rfxMetaData.doesPairExist">
          <mat-form-field subscriptSizing="dynamic">
            <mat-label>Supplier Provided Within</mat-label>
            <mat-select class=""
                id="rfxMonthFilterSelect"
                [value]="rfxMonthFilter$.value"
                (selectionChange)="rfxMonthFilter$.next($event.value)">
               @for (option of rfxMonthFilterOptions; track option) {
                 <mat-option [value]="option.value">{{ option.viewValue }}</mat-option>
               }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="conversion-info" *ngIf="vm.selectedConversionTarget || rfxMetaData.doesPairExist">
          <div class="crossed-info">
            {{ vm.verifiedCrossesCount }}/{{ vm.incumbentProducts.length }} Supplier Crossed
          </div>
          <div class="spend-info">
            {{vm.totalSpendCoverage}}% Spend Covered
          </div>
        </div>
      </div>

      <div class="end-btn-group">
        <div class="email-btn">
          <button mat-mini-fab
              [disabled]="disableDownloadBtn(rfxMetaData, vm.incumbentProducts)"
              (click)="openEmailTemplate(vm.rfxHeaderKey, rfxMetaData, vm.selectedConversionTarget, vm.incumbentProducts.length - vm.verifiedCrossesCount, vm.incumbentProducts)">
            <mat-icon>email</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="table-section">
      <div class="table-container">
        <table mat-table
            multiTemplateDataRows
            matSort
            [matSortActive]="vm.selectedConversionTarget || rfxMetaData.doesPairExist ? 'supplierVerifiedDateTime' : ''"
            [matSortDirection]="vm.selectedConversionTarget || rfxMetaData.doesPairExist ? 'desc' : ''"
            (matSortChange)="handleSortEvent($event)"
            [dataSource]="loadingConversions$.value ? [] : vm.paginatedProducts">
          <ng-container matColumnDef="expandColumn">
            <th mat-header-cell *matHeaderCellDef [attr.colspan]="1" class="grouped-headers">
              &nbsp;
            </th>
          </ng-container>

          <ng-container matColumnDef="incumbentProducts">
            <th mat-header-cell *matHeaderCellDef [attr.colspan]="this.productColumns.length" class="grouped-headers">
              <span class="header-text">{{ vm.tableFromString }}</span>
              <span class="conversion-header-text">{{ vm.tableToString}}</span>
            </th>
          </ng-container>

          <ng-container matColumnDef="conversionCheck">
            <th mat-header-cell *matHeaderCellDef [attr.colspan]="this.supplierVerificationColumns.length" class="grouped-headers">
              <span class="header-text">Conversion Check</span>
            </th>
          </ng-container>

          <ng-container matColumnDef="expandIncumbent">
            <th mat-header-cell *matHeaderCellDef class="col-expand">&nbsp;</th>
            <td mat-cell *matCellDef="let row" class="col-expand">
              <button mat-icon-button type="button"
                  *ngIf="!row.isXrefRow && hasXrefTargets(row)"
                  (click)="toggleRow(row.incumbent.pimKey)"
                  [attr.aria-expanded]="isIncumbentExpanded(row)"
                  [attr.aria-label]="isIncumbentExpanded(row) ? 'Collapse' : 'Expand'">
                <mat-icon>{{ isIncumbentExpanded(row) ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="supplierName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-supplier-name">Supplier Name</th>
            <td mat-cell *matCellDef="let row" class="col-supplier-name">{{ row.incumbent.supplierName }}</td>
          </ng-container>

          <ng-container matColumnDef="catalogNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-catalog-number">Supplier Cat #</th>
            <td mat-cell *matCellDef="let row" class="col-catalog-number">{{ row.incumbent.catalogNumber }}</td>
          </ng-container>

          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-description">Supplier Product Description</th>
            <td mat-cell *matCellDef="let row" class="col-description">{{ row.incumbent.description }}</td>
          </ng-container>

          <ng-container matColumnDef="spendCoveragePercentage">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-spend right-aligned-sorted-header">Spend</th>
            <td mat-cell *matCellDef="let row" class="col-spend">{{ formatSpendCoverage(row.spendCoveragePercentage) }}</td>
          </ng-container>

          <ng-container matColumnDef="supplierVerifiedDateTime">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-supplier-verified-date">Provided Date</th>
            <td mat-cell *matCellDef="let row" class="col-supplier-verified-date">&nbsp;</td>
          </ng-container>

          <ng-container matColumnDef="xrefTargets">
            <td mat-cell
                *matCellDef="let row"
                class="row-xref-targets"
                [attr.colspan]="incumbentColumns.length">
              <table mat-table [dataSource]="row.xrefTargets" class="bg-white">
                <ng-container matColumnDef="spacerColumn">
                  <td mat-cell *matCellDef class="col-spacer">&nbsp;</td>
                </ng-container>

                <ng-container matColumnDef="supplierName">
                  <td mat-cell *matCellDef="let xref" class="col-supplier-name">{{ xref.supplierName }}</td>
                </ng-container>

                <ng-container matColumnDef="catalogNumber">
                  <td mat-cell *matCellDef="let xref" class="col-catalog-number">{{ xref.catalogNumber }}</td>
                </ng-container>

                <ng-container matColumnDef="description">
                  <td mat-cell *matCellDef="let xref" class="col-description">{{ xref.description }}</td>
                </ng-container>

                <ng-container matColumnDef="spendCoveragePercentage">
                  <td mat-cell *matCellDef="let xref" class="col-spend">&nbsp;</td>
                </ng-container>

                <ng-container matColumnDef="supplierVerifiedDateTime">
                  <td mat-cell *matCellDef="let xref" class="col-supplier-verified-date">{{ xref.supplierVerifiedDateTime  | date:'MMMM d, yyyy' }}</td>
                </ng-container>

                <tr mat-row *matRowDef="let row; columns: xrefColumns;"></tr>
              </table>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="incumbentHeaders; sticky: true"></tr>
          <tr mat-header-row *matHeaderRowDef="incumbentColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: incumbentColumns; when: isIncumbentRow"></tr>
          <tr mat-row *matRowDef="let row; columns: ['xrefTargets']; when: isXrefRow"></tr>

          <tr *matNoDataRow>
            <td [attr.colspan]="incumbentColumns.length">
              @if(loadingConversions$ | async) {
                <ng-container *ngTemplateOutlet="loadingTemplate"/>
              } @else {
                No Products found for {{ rfxMetaData.incumbentSourceType }}: {{ rfxMetaData.incumbentDisplayValue }}
              }
            </td>
          </tr>
        </table>
      </div>

      <div class="paginator-container">
        <mat-paginator
            [pageSizeOptions]="pageSizeOptions"
            [length]="vm.incumbentProducts.length"
            [pageSize]="vm.pageEvent.pageSize"
            [pageIndex]="vm.pageEvent.pageIndex"
            (page)="handlePageEvent($event)"
            showFirstLastButtons
        />
      </div>
    </div>
  </ng-container>
</div>

<ng-template #loadingTemplate>
  <div class="loading-spinner"><mat-spinner [diameter]="100"></mat-spinner></div>
</ng-template>
